import React from "react";
import * as sharedStyled from "../../styled";
import logo from "../../../../resources/bluedot-logo.png";
import Button from "../../../Button";
import { updateLinkedAccount } from "../../helpers";
import BackwardsNavigation from "../../../BackNavigation";
import { createError } from "../../../../services/errorFactory";

export default ({
  sfmcDetails,
  canvasAccount,
  accessToken,
  region,
  setSuccess,
  setError,
  onClickBack,
}) => {
  const handleLinkToNewAccount = async () => {
    try {
      await updateLinkedAccount(
        canvasAccount,
        sfmcDetails,
        accessToken,
        region
      );
      setSuccess(true);
    } catch (error) {
      console.log(error);
      setError(createError());
    }
  };

  return (
    <sharedStyled.Container>
      <div>
        <BackwardsNavigation onClick={onClickBack} />
        <sharedStyled.MainContentContainer>
          <sharedStyled.Logo src={logo} alt="logo" />
          <h1>Update</h1>
          <h4>
            Are you sure you want to update the primary account linked to
            Bluedot?
          </h4>
          <sharedStyled.ButtonsWrapper>
            <Button onClick={() => handleLinkToNewAccount()}>
              Link to a new account
            </Button>
          </sharedStyled.ButtonsWrapper>
        </sharedStyled.MainContentContainer>
      </div>
    </sharedStyled.Container>
  );
};
